import { constructQueryStringWithRepeatedKeys } from '@/utils/queryBuilderUtils';

interface GetGlobalSearchQueryParams {
  search: string | null;
  category: string[] | null;
  partners: string[] | null;
  directory: string[] | null;
}

export const getGlobalSearchQueryUrl = ({
  search,
  category,
  partners,
  directory,
}: GetGlobalSearchQueryParams): string => {
  const queryParams: Record<string, string[]> = {};

  if (search) queryParams.query = [search];

  if (category?.length) {
    category.forEach((c) => {
      queryParams[c] = [''];
    });
  }

  if (partners?.length) {
    queryParams['partner_type_ids[]'] = partners;
  }

  if (directory?.length) {
    queryParams['user_role_ids[]'] = directory;
  }

  let baseUrl = '/api/search';

  if (Object.keys(queryParams).length > 0) {
    const queryString = constructQueryStringWithRepeatedKeys(queryParams);
    baseUrl += `?${queryString}`;
  }

  return baseUrl;
};